export default "__VITE_ASSET__M1iNFxjO__"